export interface EmailTemplateProps {
  buttonColor: string;
  linkUrl: string;
  companyName: string;
  clientName: string;
}

// required because scss doesn't copy to clipboard
export const requestButtonStyle = (buttonColor: string) => ({
  color: "white",
  fontWeight: "700",
  borderRadius: "4px",
  margin: "2px 1px",
  textDecoration: "none",
  padding: "7px 10px",
  display: "inline-block",
  backgroundColor: buttonColor,
});

export const noMargin = {
  margin: "0",
};
